export default "__VITE_ASSET__duiNtxib__"